import { Component, OnInit, ViewChild, EventEmitter, Output, ElementRef, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiserviceService } from '../../apiservice.service';
import { CommonfunctionService } from '../../services/commonfunction.service';
import { NotificationService } from '../services/notification.service';
import { ImageEditorComponent } from './image-editor/image-editor.component';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input-2';
import { CustomValidator } from './customValidator';
import { Subscription } from 'rxjs';

/**
*
* <strong>List of API using</strong>
* <ol>
* <li>umsapi_language_get</li>
* <li>umsapi_place_get</li>
* <li>umsapi_user_user_id_patch</li>
* <li>umsapi_moduletype_images_post</li>
* </ol>
*
*/

@Component({
  selector: 'app-admin-profile',
  templateUrl: './admin-profile.component.html',
  styleUrls: ['./admin-profile.component.css']
})
export class AdminProfileComponent implements OnInit, OnDestroy {
  user_detail: any;
  language_list = [];
  city_list = [];
  loader: boolean = false;
  loader1: boolean = false;
  change: boolean = false;

  profileForm: FormGroup;
  changePasswordForm:FormGroup;

  @ViewChild('imageInput') imageInput;
  profile_image: string;

  SearchCountryField = SearchCountryField;
  cuntry: string = 'us';
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.Bahrain,
    CountryISO.India,
    CountryISO.Kuwait,
    CountryISO.SaudiArabia,
    CountryISO.Switzerland,
    CountryISO.UnitedKingdom,
    CountryISO.UnitedStates,
  ];
  @Output() close = new EventEmitter
  private subs = new Subscription();
  constructor(private readonly api: ApiserviceService, private readonly fnc: CommonfunctionService,
    private readonly elementRef: ElementRef, private readonly notify: NotificationService, private readonly fb: FormBuilder,
    public dialogRef: MatDialogRef<AdminProfileComponent>,
    private readonly dialog: MatDialog
    ) {
    this.getLanguageList();
    this.user_detail = JSON.parse(localStorage.getItem('user_info'));
    let phone_number = (this.user_detail?.contact) ? this.user_detail.contact.split('-')[1] : '';
    const imgSub = this.api.profile_image.subscribe((img:string)=>{
      if(img){
         this.profile_image = img;
      }
    })
    this.subs.add(imgSub);
    this.profileForm = this.fb.group({
      'fname': [this.user_detail.fname, Validators.compose([Validators.required, Validators.maxLength(45), Validators.minLength(2), Validators.pattern('^[a-zA-Z ]*$')])],
      'lname': [this.user_detail.lname, Validators.compose([Validators.required, Validators.maxLength(45), Validators.minLength(2), Validators.pattern('^[a-zA-Z ]*$')])],
      'email': [{ value: this.user_detail.email, disabled: true }],
      'contact': [this.user_detail.contact, Validators.required],
      'city': [this.user_detail.country, Validators.required],
      'language': [this.user_detail.language, Validators.required],
      'image': [this.profile_image],

    }
    );
    this.changePasswordForm = this.fb.group({
      'oldPassword':['', Validators.required],
      'password': [null, Validators.compose([
        Validators.required,
        CustomValidator.patternValidator(/\d/, { hasNumber: true }),
        CustomValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        CustomValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
        CustomValidator.patternValidator(/[-._!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|]+/, { hasSpecialCharacters: true }),
        Validators.minLength(8), Validators.maxLength(20)
        ])
      ],
      'confirmPassword':['', Validators.required],
    },{
      validator: CustomValidator.passwordMatchValidator
    })
    setTimeout(() => { this.profileForm.get('contact')?.setValue(phone_number) }, 150);
  }

  getLanguageList() {
    const langSub = this.api.getUmsData('language')
      .subscribe(
        (res: any) => {
          if (res?.data) {
            res.data.forEach(element => {
              if (element.status == 1) {
                this.language_list.push(element);
              }
            });
          }
        }
      );
      this.subs.add(langSub);
  }

  changePass() {
    this.change = !this.change;
  }

  /**
   * This is a function for change password
   * @returns
   */
  changePassword() {
    let body = {
      "user_id": this.api.user_id,
      "new_password": this.changePasswordForm.value.password,
      "old_password": this.changePasswordForm.value.oldPassword
    }
    const changePassSub = this.api.postUmsData('change-password', body).subscribe(
     {next: (res: any) => {
      if (res && res.status == 201) {
        this.notify.notify(res.message, "success", 5000);
        this.dialogRef.close();
      }
      else {
        this.notify.notify(res.message, "warn", 5000);
      }
    }, error:(err) => {
      // this.notify.notify(err.error.message, 'error', 5000)
    }})
    this.subs.add(changePassSub);
  }


  ngOnInit() {
    this.getCityList();
  }

  getCityList() {
    const citySub = this.api.getUmsData('place')
      .subscribe({next: (res: any) => {
        if(res.status==200){
          res.data.forEach(element => {
            if (element.status == 1) {
              this.city_list.push(element);
            }
          });
        }

      },error: (err)=>{
      }});
      this.subs.add(citySub);
  }

 /**
   * This is a funtion that use to attach a file and open crop option to edit image

   * @param event event is parameter
   * @returns return void
   */

  uploadExplorImage(event){
    const dialogRef = this.dialog.open( ImageEditorComponent, {
      width:'800px',
      panelClass:'image-croper-dialog',
      data: {info: event, ratio: 1, size: 512, type: 'profile'},
      disableClose:true
    })
    const uploadExpImgSub = dialogRef.afterClosed().subscribe((result: FormData)=>{
      if(result){
        this.uploadImage(result)
      }
      this.imageInput.nativeElement.value = '';
    })
    this.subs.add(uploadExpImgSub);
  }

  /**
 * This is a funtion that use to update profile image

 * @param {FormData} formData event is parameter
 * @returns return void
 */
  uploadImage(formData:FormData) {
    this.loader = true;

    if (formData) {
      const uploadImgSub = this.api.postFileUms(`profile-image?user_id=${this.api.user_id}`, formData)
        .subscribe({next: (res: any) => {
          this.loader = false;
         if(res && res.status == 201 && res.data){
          this.profileForm.patchValue({
            image: res.data
          })
          this.notify.notify(res.message, 'success',5000)
          localStorage.setItem('profile_image', res.data);
          this.api.profile_image.next(res.data);
          this.api.getUserDetail(this.api.user_id);
         }

        },
          error: (err) => {
            this.loader = false;
          }}
        );
        this.subs.add(uploadImgSub);
    }
  }
  openExplorer(type) {
    if (type == 'image') {
      let e = $(this.elementRef.nativeElement);
      e.find("#image_input").click();
    }
  }
  saveUserdetail(e): void {
    let user_name ;
    this.loader1 = true;
    let lang_code = e.value.language;
    let lang_detail = this.fnc.getArrayValue('language_code', lang_code, this.api.language_list);

   let attribute   ={};
   attribute[1]={"first_name": e.value.fname, "last_name": e.value.lname }
  let number = e.value.contact.e164Number.split(e.value.contact.dialCode)[1]
    let body = {
      "attributes": attribute,
      "phone_number": e.value.contact.dialCode+'-'+number,
      "gender": e.value.gender,
      "nationality": e.value.city,
      "profile_image": this.profile_image
    }
    const userSub = this.api.patchUmsData(`user?updated_by=${this.api.user_id}&id=${this.api.user_id}`, body)
      .subscribe({next:(res: any) => {
        this.loader1 = false;
        if (res && res.status == 201) {
          this.api.getUserDetail(this.api.user_id);
          this.notify.notify(res.message, 'success',5000);
          this.close.emit()
        }
        else {
          this.notify.notify(res.message, 'warn', 5000);

        }
      }, error:err => {
        this.loader1 = false;
      }
  })
  this.subs.add(userSub);


  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
